var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.081,
    height: 30.086,
    viewBox: "0 0 30.081 30.086",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "share",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2584",
    "data-name": "Raggruppa 2584"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3396",
    "data-name": "Tracciato 3396",
    d: "M25.38,1.88A2.82,2.82,0,1,0,28.2,4.7,2.82,2.82,0,0,0,25.38,1.88ZM20.68,4.7a4.7,4.7,0,1,1,1.134,3.061L9.184,13.626a4.7,4.7,0,0,1,0,2.828l12.63,5.866a4.7,4.7,0,1,1-.917,1.647L8.266,18.1a4.7,4.7,0,1,1,0-6.121L20.9,6.114A4.7,4.7,0,0,1,20.68,4.7ZM4.7,12.22a2.82,2.82,0,1,0,2.82,2.82A2.82,2.82,0,0,0,4.7,12.22ZM25.38,22.56a2.82,2.82,0,1,0,2.82,2.82A2.82,2.82,0,0,0,25.38,22.56Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share_icon.ba37c6e4f078e19a477dba3699bc1597.svg";
export { ForwardRef as ReactComponent };